import { Popover } from "antd";
import PropTypes from "prop-types";

const LinksListPopoverWrapper = ({ content, children }) => {
  if (!content) return children;

  return (
    <Popover content={content} placement="left">
      {children}
    </Popover>
  );
};

LinksListPopoverWrapper.propTypes = {
  content: PropTypes.node,
  children: PropTypes.node,
};

export default LinksListPopoverWrapper;
